import script from "./InputValidationConfig.vue?vue&type=script&lang=ts&setup=true"
export * from "./InputValidationConfig.vue?vue&type=script&lang=ts&setup=true"

import "./InputValidationConfig.vue?vue&type=style&index=0&id=3c2f2ab4&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c2f2ab4"]])

export default __exports__